import { render, staticRenderFns } from "./commits_header.vue?vue&type=template&id=29a1439b&"
import script from "./commits_header.vue?vue&type=script&lang=js&"
export * from "./commits_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports